module.exports = {};



//////////////////
// WEBPACK FOOTER
// ../~/core-js/modules/_iterators.js
// module id = 85
// module chunks = 0